export default __webpack_public_path__ + "static/media/mask_group_12-33.f60cad33.png";